import { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import LoginForm from '@/components/authentication/LoginForm';
import { NS } from '@/constants';
import { PAGES } from '@/constants/pages';
import { useAppSelector } from '@/redux';
import { initializeStore } from '@/redux/initialize-store';
import { getI18NextConfigForLocale } from '@/utils/locales';
import { sanitizeObject } from '@/utils/millesimaUtils';
import { prefetchLayout } from '@/utils/prefetchLayout';
import styles from './privateWebsite.module.scss';

const NAMESPACES = [NS.COMMON, NS.ALTER];

export const PrivateWebsite: NextPage = () => {
	const loggedUser = useAppSelector(({ auth }) => auth.loggedUser);
	return (
		<div className={styles['private-web-site']} data-test-id="private-web-site">
			{!loggedUser && (
				<div className={styles['form-container']}>
					<LoginForm showSubscribe={false} />
				</div>
			)}
		</div>
	);
};

export const getServerSideProps = async (ctx) => {
	const store = initializeStore({ ssrContext: ctx });
	const layoutOptions = await prefetchLayout(ctx, store);
	const {
		root: { storeConf },
		auth: { loggedUser },
	} = store.getState();
	const { locale } = storeConf || ctx;
	const translate = await serverSideTranslations(locale, NAMESPACES, getI18NextConfigForLocale(locale));
	const { privateWebsite } = storeConf;

	if (!privateWebsite || loggedUser) {
		console.error('privateWebsite access is not authorized, redirect to home page');
		return {
			redirect: {
				destination: PAGES.HOME,
				permanent: false,
			},
		};
	}

	return {
		props: sanitizeObject({
			...translate,
			layoutOptions: {
				...layoutOptions,
				withPromotionHeader: false,
				withHeader: false,
				withNavBar: false,
				withFooter: false,
			},
			initialReduxState: store.getState(),
		}),
	};
};

export default PrivateWebsite;
